import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import { JSONSchema7 } from 'json-schema';
import { SessionItemData } from '../../../workflow/services/session-item-data';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';
import configStub from '@interfaces/schemas/participant-type.json';
import { ParticipantService } from '../../../services/participants/participant.service';
import {IParticipant, IParticipantConfig} from '@interfaces/interfaces';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Resolver } from '@stoplight/json-ref-resolver';
import { filter } from 'rxjs/operators';

class StubClass {
	public schemaStub$: BehaviorSubject<JSONSchema7>;
}

@Component({
	selector: 'app-formular-showcase',
	templateUrl: './formular-showcase.component.html'
})
export class FormularShowcaseComponent implements OnDestroy, OnInit {
	@Input() editFormular = false;

	resolvedSchema: JSONSchema7;
	data: SessionItemData = null;
	participantFormID = 'form-create-participant';
	createParticipantButton: SplitButtonElement = {
		title: 'actions.create',
		type: 'primary',
		icon: 'save',
	};
	editParticipantButton: SplitButtonElement = {
		title: 'actions.edit',
		type: 'primary',
		icon: 'edit',
	};
	deleteParticipantButton: SplitButtonElement = {
		title: 'actions.delete',
		type: 'default',
		icon: 'trash',
	};
	cancelParticipantButton: SplitButtonElement = {
		title: 'actions.cancel',
		type: 'default',
		icon: 'x',
	};
	public participant: IParticipant = {
		id: '123',
		data: {
			personal: {
				firstName: 'Freddie',
				lastName: 'Mercury',
				birthday: '1946-09-05',
			},
			address: {
				address: '12 Stafford Terrace',
				city: 'London',
				zipCode: 'W8 7BH',
				country: 'UK',
			},
			projects: {

			}
		},
	};
	private subscription = new Subscription();
	private participantServiceStub: Partial<ParticipantService> & StubClass = {
		schemaStub$: new BehaviorSubject<JSONSchema7>(null),
		get participantsConfigOfActiveProject() { return {_id: 'default', schema: configStub} as IParticipantConfig; },
		get resolvedParticipantsConfigSchema$(): Observable<JSONSchema7> {
			const config = configStub as JSONSchema7;
			(new Resolver()).resolve(config).then(r => {
				this.schemaStub$.next(r.result);
			});
			return this.schemaStub$.pipe(filter(x => !!x));
		},
	};

	constructor() {

	}

	ngOnInit(): void {
		this.subscription.add(
			this.participantServiceStub.resolvedParticipantsConfigSchema$.subscribe(resolvedSchema => {
				this.resolvedSchema = resolvedSchema;
				this.data = new SessionItemData(this.participant.data);
			})
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	submit(isFormValid: boolean): void {
		console.log('submit', isFormValid);
	}
}
